// Centralized logging for the AskPsd feature so call sites don't sprinkle
// raw console.* calls — swap the implementation here to wire up real
// telemetry (AppDynamics/Sentry) without touching every caller.
const isProd = process.env.NODE_ENV === 'production';

export const logger = {
  error: (message, err) => {
    // Errors are always logged (including in production) so support/ops
    // can diagnose issues from browser consoles or shipped logs.
    console.error(`[AskPSD] ${message}`, err);
  },
  warn: (message, err) => {
    console.warn(`[AskPSD] ${message}`, err);
  },
  debug: (...args) => {
    if (!isProd) {
      console.debug('[AskPSD]', ...args);
    }
  },
};
